import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shared-controls',
  templateUrl: './shared-controls.component.html',
  styleUrls: ['./shared-controls.component.css']
})
export class SharedControlsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/shared-controls/shared-controls.component.ts